<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title class="text-h6">
        Editando {{ saleLinks.length }} links de venda
      </v-card-title>
      <v-card-text class="pt-1">
        <v-form v-model="valid" ref="form">
          <v-select
            outlined
            v-model="selectedTicketGroups"
            :items="ticketGroups"
            :rules="[(v) => !!v.length || 'Ao menos um setor é obrigatório']"
            label="Setores"
            multiple
            chips
            small-chips
          ></v-select>
        </v-form>
        <v-alert v-if="error" type="error" text>
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-progress-linear
        v-if="loading"
        :value="(progress / saleLinks.length) * 100"
      />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="ml-1"
          color="secondary"
          text
          :disabled="loading"
          @click="close"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!valid"
          @click="save"
          :loading="loading"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import ORGANIZATION from "@/services/admin/organization";

const defaultSaleLink = () => ({
  name: "",
  active: true,
  ticketGroups: [],
  saleLinks: [],
});

export default {
  data: () => ({
    dialog: false,
    loading: false,
    valid: false,
    error: false,
    progress: 0,
    saleLinks: [],
    selectedTicketGroups: [],
  }),

  methods: {
    open(data = []) {
      this.saleLinks = data;
      this.selectedTicketGroups = [];
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.loading = false;
        this.error = false;
        this.saleLinks = [];
      });
    },
    async save() {
      try {
        this.loading = true;
        this.error = false;
        this.progress = 0;

        let party = this.party;

        for (let i = 0; i < this.saleLinks.length; i++) {
          const saleLink = this.saleLinks[i];
          await ORGANIZATION.party.saleLink.update(
            party.organizationId,
            party.id,
            {
              ...saleLink,
              ticketGroups: this.selectedTicketGroups,
            }
          );
          this.progress++;
        }
        this.$emit("success");
        this.close();
      } catch (e) {
        this.error = e.message;
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
  },
  mounted() {
    this.$parent.$on("sale-link-multi-modal", this.open);
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
    ticketGroups: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
